import { motion } from "framer-motion";
import { Overline, Reveal } from "./Shared";
import { MANIFESTO } from "../../lib/site";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/ca301ed46e512b32ccca768edd74d8a172c9ab13b75a8af20bd8865d163dcab2.jpeg";

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 md:py-32 bg-charcoal border-y border-white/10" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div className="lg:sticky lg:top-28">
          <Overline>Why Upper Class</Overline>
          <h2 className="mt-5 font-heading font-light text-4xl md:text-6xl text-white leading-[1.02]">
            A standard held <span className="italic text-gold">without compromise</span>
          </h2>
          <Reveal delay={0.1}>
            <div className="mt-10 relative overflow-hidden rounded-sm border border-white/10 aspect-[3/4]">
              <img src={IMG} alt="Professional chauffeur assisting with luggage" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 to-transparent" />
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group flex gap-6 md:gap-8 py-8 border-b border-white/10 first:pt-0"
              data-testid={`manifesto-item-${m.no}`}
            >
              <span className="font-heading text-4xl md:text-5xl text-transparent leading-none [-webkit-text-stroke:1px_rgba(212,175,55,0.6)] transition-colors duration-500 group-hover:text-gold">
                {m.no}
              </span>
              <div>
                <h3 className="font-heading text-2xl md:text-3xl text-white">{m.title}</h3>
                <p className="mt-3 text-white/55 text-sm md:text-base leading-relaxed max-w-md">{m.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
